const SHIKI_LANGS = new Set([
  'python',
  'r',
  'json',
  'bash',
  'shell',
  'sh',
  'typescript',
  'ts',
  'javascript',
  'js',
  'markdown',
  'md',
  'text',
  'plain',
  'yaml',
  'yml',
])

/** Map markdown fence language to a Shiki web-bundle language id. */
export function mapShikiLanguage(language: string | undefined): string {
  const lang = (language || 'text').toLowerCase()
  if (lang === 'plain') return 'text'
  if (lang === 'ts') return 'typescript'
  if (lang === 'js') return 'javascript'
  if (lang === 'md') return 'markdown'
  if (lang === 'sh') return 'bash'
  if (SHIKI_LANGS.has(lang)) return lang
  return 'text'
}
